module.exports = __webpack_public_path__ + "static/media/360south-logo-white.266ea67b.svg";